module.exports = __webpack_public_path__ + "img/2-center-grey.37cbf1d6.png";